module.exports = __webpack_public_path__ + "static/media/book_zarb_ae_kaleem_urdu_3.213c96c3.jpg";